import { FC, ReactNode, useEffect, useState } from 'react';

export const NoSsr: FC<{ children: ReactNode }> = ({ children }) => {
  const [canRender, setCanRender] = useState(false);

  useEffect(() => {
    setCanRender(true);
  }, []);

  return canRender ? <>{children}</> : null;
};
